import axios from 'axios'
import axiosRetry from 'axios-retry'

import { ADDRESSCLOUD_ENV } from '../constants'

// Configure retries
axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

export default class MatchAPI {

  apiKey
  clientId
  userId
  headers

  constructor(apiKey, clientId, userId) {
    this.apiKey = apiKey
    this.clientId = clientId
    this.userId = userId
    this.geocode = this.geocode.bind(this)
    this.lookup = this.lookup.bind(this)
    this.headers = { 'x-api-key': apiKey, 'x-client-id': clientId, 'x-user-id': userId }
  }

  async geocode(params) {
    const resp = await axios.get(`https://${ADDRESSCLOUD_ENV}.addresscloud.com/match/v1/address/geocode`, {
      mode: 'cors',
      params,
      headers: this.headers
    })
    return resp.data
  }

  async lookup(id) {
    let params = { }
    const resp = await axios.get(`https://${ADDRESSCLOUD_ENV}.addresscloud.com/match/v1/address/lookup/byId/${id}`, {
      mode: 'cors',
      params,
      headers: this.headers
    })
    return resp.data
  }

}
